import {
  Link,
  VStack,
  HStack,
  Tooltip,
  useTheme,
  Text,
  Box,
} from '@wegroup/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { IconDocumentFilled } from 'wg-fe-ui';
import { OfferDocumentLink } from '../../../../../types/ProductFactory';

interface Props {
  documents: OfferDocumentLink[];
}

const OfferDocuments: React.FC<React.PropsWithChildren<Props>> = ({
  documents,
}) => {
  const { colors } = useTheme();
  const { t } = useTranslation();

  return (
    <VStack spacing="1" align="stretch">
      {documents.map((doc, index) => (
        <HStack key={`Document_${index}`} spacing="1">
          <Box flexShrink={0}>
            <IconDocumentFilled size={20} color={colors.gray[500]} />
          </Box>
          {doc.url ? (
            <Link
              variant="gray"
              textStyle="smallBody"
              href={doc.url}
              target="_blank"
            >
              {doc.label}
            </Link>
          ) : (
            <Tooltip
              label={t('This document is currently unavailable')}
              aria-label="A tooltip"
            >
              <Text color="gray.500" cursor="pointer" textStyle="smallBody">
                {doc.label}
              </Text>
            </Tooltip>
          )}
        </HStack>
      ))}
    </VStack>
  );
};

export default OfferDocuments;
